import { absoluteUrl, DEFAULT_OG_IMAGE, SITE_MOTTO, SITE_URL } from './seoConfig';

export function organizationJsonLd() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Cassette',
    url: SITE_URL,
    logo: absoluteUrl('/cassette-logo.svg'),
    sameAs: [],
  };
}

export function webSiteJsonLd() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Cassette',
    url: SITE_URL,
    description: SITE_MOTTO,
  };
}

export function musicSoftwareApplicationJsonLd() {
  return {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    name: 'Cassette',
    applicationCategory: 'BusinessApplication',
    operatingSystem: 'Web',
    url: SITE_URL,
    image: DEFAULT_OG_IMAGE,
    description:
      'Music project workspace to organize demos, mixes, artwork, and promo. Collaborate with band and producers. Store files in your own cloud or add Cassette Cloud hosted storage.',
    featureList: [
      'Track and release workflow',
      'Audio, artwork, and promo asset management',
      'Kanban progress tracking',
      'Your cloud (Drive, Dropbox, OneDrive, Yandex) or Cassette Cloud',
      'Real-time collaboration',
      'Installable PWA',
      'MCP integration for Cursor and Claude',
    ],
    offers: [
      { '@type': 'Offer', name: 'Starter', price: '0', priceCurrency: 'USD' },
      { '@type': 'Offer', name: 'Artist (your cloud)', price: '5', priceCurrency: 'USD' },
      { '@type': 'Offer', name: 'Artist + Cassette Cloud', price: '10', priceCurrency: 'USD' },
      { '@type': 'Offer', name: 'Studio (your cloud)', price: '25', priceCurrency: 'USD' },
      { '@type': 'Offer', name: 'Studio + Cassette Cloud', price: '50', priceCurrency: 'USD' },
    ],
  };
}

export function landingJsonLd() {
  return [organizationJsonLd(), webSiteJsonLd(), musicSoftwareApplicationJsonLd()];
}

export type FaqItem = { question: string; answer: string };

export function faqPageJsonLd(items: FaqItem[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: items.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };
}

export function techArticleJsonLd(opts: {
  title: string;
  description: string;
  path: string;
}) {
  return {
    '@context': 'https://schema.org',
    '@type': 'TechArticle',
    headline: opts.title,
    description: opts.description,
    url: absoluteUrl(opts.path),
    author: { '@type': 'Organization', name: 'Cassette' },
    publisher: {
      '@type': 'Organization',
      name: 'Cassette',
      logo: { '@type': 'ImageObject', url: absoluteUrl('/cassette-logo.svg') },
    },
  };
}

export function articleJsonLd(opts: {
  title: string;
  description: string;
  path: string;
}) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: opts.title,
    description: opts.description,
    url: absoluteUrl(opts.path),
    author: { '@type': 'Organization', name: 'Cassette' },
    publisher: {
      '@type': 'Organization',
      name: 'Cassette',
      logo: { '@type': 'ImageObject', url: absoluteUrl('/cassette-logo.svg') },
    },
  };
}
